import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EnabledIntegration, IntegrationsItem } from "../typeDefs/integrations";

export interface IntegrationsState {
    integrations: IntegrationsItem[];
    integrationsLinks: string[];
    enabledIntegrations: EnabledIntegration[];
    loading: boolean;
}

const initialState: IntegrationsState = {
    integrations: [],
    integrationsLinks: ["yardi-data", "property-gps"],
    enabledIntegrations: [],
    loading: false,
};

export const integrationsSlice = createSlice({
    name: "integrations",
    initialState,
    reducers: {
        setEnabledIntegrations: (
            state,
            action: PayloadAction<EnabledIntegration[]>
        ) => {
            state.enabledIntegrations = action.payload;
        },
        setIntegrationsLinks: (state, action: PayloadAction<string[]>) => {
            state.integrationsLinks = action.payload;
        },
        setIntegrations: (state, action: PayloadAction<IntegrationsItem[]>) => {
            state.integrations = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const {
    setIntegrations,
    setLoading,
    setIntegrationsLinks,
    setEnabledIntegrations,
} = integrationsSlice.actions;

export default integrationsSlice.reducer;
